import { companyNameLabel, hasCompanyName } from '../../../customerName';
import { CustomerRow } from '../../../CustomersV2.types';
import { canOpenProfile } from '../../../profileEligibility';

export const CompanyNameCell = ({
  row,
  onCompanyClick,
}: {
  row: CustomerRow;
  onCompanyClick: (buyerStateKey: string) => void;
}) => {
  const label = companyNameLabel(row);
  const named = hasCompanyName(row);

  // Orion's table cell sets the `font` shorthand, which resets font-style, so
  // the placeholder's italic has to be forced.
  if (!canOpenProfile(row)) {
    return named ? (
      <span>{label}</span>
    ) : (
      <span className="!italic text-primary-40">{label}</span>
    );
  }

  return (
    <button
      type="button"
      // Tailwind preflight is off, so a bare button keeps the UA font. `font`
      // must be inherited as a shorthand — `font-[inherit]` would only carry
      // font-family and drop the cell's size and weight.
      className={`cursor-pointer border-none bg-transparent p-0 text-left text-primary-40 underline [font:inherit] ${
        named ? '' : '!italic'
      }`}
      onClick={() => onCompanyClick(row.buyer_state_key)}
    >
      {label}
    </button>
  );
};
